module.exports = __webpack_public_path__ + "img/5.43fb4d3b.jpg";